import { Routes } from '@angular/router';

import { MpsIsAdminGuard } from '../mps/guards/mps-isadmin.guard';
import { MpsLoggedInGuard } from '../mps/guards/mps-loggedin.guard';
import { applicationRouteNames } from './application-route-names';
import { BackOfficeGuard } from './guards/back-office.guard';
import { ReportingGuard } from './guards/reporting.guard';

export const applicationRoutes: Routes = [
  {
    path: applicationRouteNames.form,
    loadComponent: () => import('./form/form.component').then((m) => m.FormComponent),
    canActivate: [MpsLoggedInGuard],
    data: { title: 'general.navigation.adhesion' },
  },
  {
    path: applicationRouteNames.successAdhesion,
    loadComponent: () => import('./form/success/success.component').then((m) => m.SuccessComponent),
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.reporting,
    loadComponent: () => import('./reporting/reporting.component').then((m) => m.ReportingComponent),
    canActivate: [MpsLoggedInGuard, ReportingGuard],
    data: { title: 'general.navigation.reporting' },
  },
  {
    path: applicationRouteNames.backOffice,
    loadComponent: () => import('./back-office/back-office.component').then((m) => m.BackOfficeComponent),
    canActivate: [MpsLoggedInGuard, BackOfficeGuard],
    data: { title: 'general.navigation.backOffice' },
  },
  {
    // No `data.title` on purpose: the Administration menu is hidden from the nav for everyone.
    // The routes stay reachable by direct URL, restricted to SuperAdmins via MpsIsAdminGuard.
    path: applicationRouteNames.administration,
    canActivate: [MpsIsAdminGuard],
    canLoad: [MpsIsAdminGuard],
    children: [
      {
        path: applicationRouteNames.users,
        loadComponent: () => import('./administration/users/list/list.component').then((m) => m.ListComponent),
        data: { title: 'general.navigation.users' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.lokalise,
        loadComponent: () => import('./administration/lokalise/lokalise.component').then((m) => m.LokaliseComponent),
        data: { title: 'general.navigation.lokalise' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
    ],
  },
];
